import type { JSX } from 'react'
import type { IAuthFormBoxProps } from '../AuthFormBox'

import { AuthFormBox } from '../AuthFormBox'
import {
  AuthFormBoxAlignItems,
  AuthFormBoxPaddings,
  AuthFormBoxRowGaps,
} from '../AuthFormBox.h'

export interface IAuthFormBoxTemplateProps extends IAuthFormBoxProps {}

export const AuthFormBoxTemplate = ({
  children,
  width = 460,
  padding = AuthFormBoxPaddings.SIZE_140,
  rowGap = AuthFormBoxRowGaps.SIZE_10,
  alignItems = AuthFormBoxAlignItems.FlexStart,
  ...rest
}: IAuthFormBoxTemplateProps): JSX.Element => (
  <AuthFormBox
    width={width}
    padding={padding}
    rowGap={rowGap}
    alignItems={alignItems}
    {...rest}
  >
    {children}
  </AuthFormBox>
)

AuthFormBoxTemplate.displayName = 'AuthFormBoxTemplate'
